import React from "react";
import Lottie from "react-lottie-player";
import emptyAnimation from "../../../resources/empty-animation.json";
import Text from "../../library/text";
import { Title } from "../../library/title";

import "./style.scss";

const Index = ({ title, description }) => {
  return (
    <div className="empty-table-container">
      <div className="animation-container">
        <Lottie
          animationData={emptyAnimation}
          loop
          play
          className="animation-player"
        />
      </div>
      <Title>{title ? title : ""}</Title>
      <Text maxWidth={445} align="center">
        {description ? description : ""}
      </Text>
    </div>
  );
};

export default Index;
